<template>
  <div class="container">
    <div class="date-wrap">
      <div class="url">
        Drivmedelsguiden.se
      </div>
      <div class="date">
        {{ date }}
      </div>
    </div>
    <h1>Resultat av jämförelse</h1>
    <div>
      <div class="ingress">
        Tack för att du använder drivmedelsguiden.se - en tjänst från Volvofinans Bank.<br/>
        Nedan följer en sammanställning av dina val.
      </div>
    </div>
    <div>
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      date () {
        const dt = new Date()
        let month = dt.getMonth()
        let day = dt.getDate()
        if (month.toString().length === 1) {
          month = '0' + month
        }

        if (day.toString().length === 1) {
          day = '0' + day
        }

        return dt.getFullYear() + '-' + month + '-' + day
      }
    }
  }
</script>

<style rel="stylesheet/scss" type="text/css" lang="scss" scoped>

  .container {
    text-align: center;
    overflow: hidden;
    position: relative;
    margin-bottom: 30px;

    .date-wrap {
      width: calc(100% - 40px);
      display: inline-block;
      overflow: hidden;
      padding: 20px;

      .url {
        float: left;
      }

      .date {
        float: right;
      }
    }

    h1 {
      letter-spacing: 0.05em;
      font-weight: bold;
      margin-top: 80px;
      font-size: 2em;
    }

    .ingress {
      display: inline-block;
      margin-top: 5px;
      line-height: 1.4em;
    }

    .line {
      display: inline-block;
      width: 300px;
      border-bottom: 2px solid #178394;
    }
  }
</style>



// WEBPACK FOOTER //
// printHeader.vue?c92c16e8